"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const vue_property_decorator_1 = require("vue-property-decorator");
const bmk_ui_framework_1 = require("@biomemakers/bmk_ui_framework");
const TableSummaryFilter_vue_1 = __importDefault(require("@becrop/components/Results/Projects/Components/MAAReports/TableSummaryFilter.vue"));
const trans_1 = require("@common/tsutils/trans");
let TableSummaryFiltersRow = class TableSummaryFiltersRow extends vue_property_decorator_1.Vue {
    constructor() {
        super(...arguments);
        this.claimOptions = this.isStudy
            ? [
                { label: (0, trans_1.trans)('summary.maa.claims.E'), id: 'e' },
                { label: (0, trans_1.trans)('summary.maa.claims.T'), id: 't' },
                { label: (0, trans_1.trans)('summary.maa.claims.M'), id: 'm' },
                { label: (0, trans_1.trans)('summary.maa.claims.NT'), id: 'nt' },
                { label: (0, trans_1.trans)('summary.maa.claims.NE'), id: 'ne' },
            ]
            : [
                { label: (0, trans_1.trans)('summary.maa.claims.E'), id: 'e' },
                { label: (0, trans_1.trans)('summary.maa.claims.T'), id: 't' },
                { label: (0, trans_1.trans)('summary.maa.claims.M'), id: 'm' },
                { label: (0, trans_1.trans)('summary.maa.claims.NT'), id: 'nt' },
                { label: (0, trans_1.trans)('summary.maa.claims.NE'), id: 'ne' },
            ];
        this.defaultValue = null;
    }
    get internal_theme() {
        if (this.theme)
            return this.theme;
        return this.$theme.current.value;
    }
    get isStudy() {
        return this.type === 'study';
    }
    get timesOrder() {
        const times = [];
        for (const time of this.times) {
            times.push(`T${time.time}`);
        }
        return times;
    }
    get showByOptions() {
        let options = [
            { id: 'locations', label: (0, trans_1.trans)('summary.maa.table.locations') },
            { id: 'treatments', label: (0, trans_1.trans)('summary.maa.table.products') },
        ];
        if (this.type !== 'study') {
            options.push({ id: 'times', label: (0, trans_1.trans)('summary.maa.table.times') });
        }
        return options;
    }
    get preferredValueOptions() {
        let options = [
            { id: 'fold_change', label: (0, trans_1.trans)('summary.maa.table.fold_change') },
            { id: 'score_change', label: (0, trans_1.trans)('summary.maa.table.score_change') },
        ];
        return options;
    }
    changeLocation(l) {
        this.$emit('changeLocation', l);
    }
    changeEffectName(en) {
        this.$emit('changeEffectName', en);
    }
    changeCategory(c) {
        this.$emit('changeCategory', c);
    }
    changeParentCategory(parentCategory) {
        this.$emit('changeParentCategory', parentCategory);
    }
    changeTime(c) {
        const numeroExtraido = c.match(/\d+/);
        if (c.length > 1) {
            this.$emit('changeTime', 'T' + numeroExtraido[0]);
        }
        else {
            this.$emit('changeTime', '');
        }
    }
    changeMetric(m) {
        this.$emit('changeMetric', m);
    }
    changeClaim(r) {
        if (r.id)
            r = r.id;
        this.$emit('changeClaim', r);
    }
    changeShowBy(showBy) {
        this.$emit('changeShowBy', showBy.id);
    }
    changePreferredValue(changePreferred) {
        this.$emit('changePreferredValue', changePreferred.id);
    }
    changeRelevant(relevant) {
        this.$emit('changeRelevant', relevant);
    }
    resetAllFilters() {
        this.defaultValue = (0, trans_1.trans)('summary.filter.default');
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], TableSummaryFiltersRow.prototype, "theme", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: 'study' })
], TableSummaryFiltersRow.prototype, "type", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: [] })
], TableSummaryFiltersRow.prototype, "locations", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: [] })
], TableSummaryFiltersRow.prototype, "effectNames", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: [] })
], TableSummaryFiltersRow.prototype, "categories", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: [] })
], TableSummaryFiltersRow.prototype, "parentCategories", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: [] })
], TableSummaryFiltersRow.prototype, "metrics", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Object, default: [] })
], TableSummaryFiltersRow.prototype, "times", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], TableSummaryFiltersRow.prototype, "currentFocus", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], TableSummaryFiltersRow.prototype, "defaultMetricValue", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], TableSummaryFiltersRow.prototype, "defaultLocationValue", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], TableSummaryFiltersRow.prototype, "defaultCategoryValue", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], TableSummaryFiltersRow.prototype, "defaultParentCategoryValue", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], TableSummaryFiltersRow.prototype, "defaultClaimValue", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], TableSummaryFiltersRow.prototype, "defaultTimeValue", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: String, default: null })
], TableSummaryFiltersRow.prototype, "defaultEffectNameValue", void 0);
__decorate([
    (0, vue_property_decorator_1.Prop)({ type: Boolean, default: false })
], TableSummaryFiltersRow.prototype, "showOnlyRelevants", void 0);
TableSummaryFiltersRow = __decorate([
    (0, vue_property_decorator_1.Options)({
        emits: [
            'changeLocation',
            'changeCategory',
            'changeParentCategory',
            'changeMetric',
            'changeClaim',
            'changeShowBy',
            'changePreferredValue',
            'changeEffectName',
            'resetAllFilters',
            'changeTime',
            'changeRelevant'
        ],
        components: {
            TableSummaryFilter: TableSummaryFilter_vue_1.default,
            Link: bmk_ui_framework_1.Link,
            CheckBoxV2: bmk_ui_framework_1.CheckBoxV2
        },
    })
], TableSummaryFiltersRow);
exports.default = TableSummaryFiltersRow;
